import {useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types'
import {useMsal} from '@azure/msal-react'
import TimeoutConfig from '../../configs/timeoutConfig.json'
import CustomDialog from '../Common/CustomDialog'
import {
  StyledActionAddButton,
  StyledActionResetButton,
  StyledInterestTagTitleContainer
} from '../Campaigns/AskGivePrism/Styles'
import {StyledActionBox} from '../Common/Styles'
import {useApolloClient} from '@apollo/client'
import useTabHighlightNotification from '../../helper/useTabHighlightNotification'
import {StyledTypography} from './IdleTimeoutNotificationStyles'
import theme from '../../themes/index'

const IdleTimeoutContent = ({countDownDisplay}) => {
  return <StyledTypography>{`Your session will end due to inactivity in ${countDownDisplay} mins`}</StyledTypography>
}

const IdleTimeoutNotification = ({isOpen, setTimeOutInactive}) => {
  const {instance} = useMsal()
  const [countDown, setCountDown] = useState(0)
  const [countDownDisplay, setCountDownDisplay] = useState('')
  const intervalRef = useRef(null)
  const client = useApolloClient()
  const [setTabNotification, clearTabNotification] = useTabHighlightNotification()

  useEffect(() => {
    if (isOpen) {
      setTimerDisplay(TimeoutConfig.APP_NOTIFICATION_TIMEOUT_MINUTES, TimeoutConfig.APP_NOTIFICATION_TIMEOUT_SECONDS)
      startCountDown(TimeoutConfig.APP_NOTIFICATION_TIMEOUT_MINUTES, TimeoutConfig.APP_NOTIFICATION_TIMEOUT_SECONDS)
    }
    return () => {
      stopCountDown()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  useEffect(() => {
    if (isOpen && countDown <= 0) handleLogout()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countDown])

  function startCountDown(minutes, seconds) {
    setTabNotification()
    const interval = setInterval(() => {
      if (seconds > 0) {
        seconds = seconds - 1
      }
      if (seconds === 0) {
        if (minutes !== 0) {
          minutes = minutes - 1
          seconds = 59
        }
      }
      setCountDown(minutes + seconds * 1000)
      setTimerDisplay(minutes, seconds)
    }, 1000)
    intervalRef.current = interval
  }

  function setTimerDisplay(minutes, seconds) {
    const displaySeconds = ('' + seconds)?.length > 1 ? seconds : '0' + seconds
    const displayMinutes = ('' + minutes)?.length > 1 ? minutes : '0' + minutes
    const displayTime = displayMinutes + ':' + displaySeconds
    setCountDownDisplay(displayTime)
  }

  function stopCountDown() {
    clearTabNotification()
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
  }

  const handleLogout = () => {
    handleCleanUp()
    client?.clearStore()
    instance?.logoutRedirect()
  }

  const handleContinue = () => {
    handleCleanUp()
  }

  const handleCleanUp = () => {
    stopCountDown()
    setTimeOutInactive()
  }

  if (!isOpen) return null

  const handleLoggedIn = (event) => {
    event.preventDefault()
    handleContinue()
  }

  return (
    <CustomDialog
      open={isOpen}
      showDivider={false}
      maxWidth="xs"
      timelineDialog={true}
      showCloseBtn={false}
      title={
        <StyledInterestTagTitleContainer sx={{fontSize: theme.typography.heading.fontSize.l}}>
          Continue session?
        </StyledInterestTagTitleContainer>
      }
      content={<IdleTimeoutContent countDownDisplay={countDownDisplay} />}
      actions={
        <StyledActionBox>
          <StyledActionResetButton onClick={handleLogout}>Logout</StyledActionResetButton>
          <StyledActionAddButton onClick={handleLoggedIn}>Stay logged in</StyledActionAddButton>
        </StyledActionBox>
      }
    />
  )
}

IdleTimeoutNotification.propTypes = {
  isOpen: PropTypes.bool,
  setTimeOutInactive: PropTypes.func
}

IdleTimeoutContent.propTypes = {
  countDownDisplay: PropTypes.string
}

export default IdleTimeoutNotification
